import type { AxiosError } from 'axios'

import { clearTokens } from '@/data/api/token'
import type { TApiErrorResponse } from '@/data/api/types'
import { getApiErrorMessage } from '@/data/api/types'
import { useAuthStore } from '@/store/authStore'

export const errorInterceptor = async (error: AxiosError<TApiErrorResponse>): Promise<never> => {
  const status = error.response?.status

  if (status === 401) {
    clearTokens()
    await useAuthStore.getState().logout()
  }

  const message = getApiErrorMessage(error)
  return Promise.reject(new Error(message))
}
